/**
 * Date-extensions locale Nepalese [ne]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ne', {
    monthNames: ['जनवरी','फेब्रुवरी','मार्च','अप्रिल','मई','जुन','जुलाई','अगष्ट','सेप्टेम्बर','अक्टोबर','नोभेम्बर','डिसेम्बर'],
    monthShortNames: ['जन.','फेब्रु.','मार्च','अप्रि.','मई','जुन','जुलाई.','अग.','सेप्ट.','अक्टो.','नोभे.','डिसे.'],
    dayNames: ['आइतबार','सोमबार','मङ्गलबार','बुधबार','बिहिबार','शुक्रबार','शनिबार'],
    dayShortNames: ['आइत.','सोम.','मङ्गल.','बुध.','बिहि.','शुक्र.','शनि.']
});
